import { render, staticRenderFns } from "./BundleForm.vue?vue&type=template&id=736ac2f0&"
import script from "./BundleForm.vue?vue&type=script&lang=js&"
export * from "./BundleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports